'use strict'

jQuery(document).ready(function($) {
	console.log('JTF Child Theme Main Script Loaded')

	// Add a placeholder text to search bar:
	$( '#s' ).attr( 'placeholder', 'Search the site' );

	$('.news-carousel__owl-news').show();
	$('.news-carousel__owl-events').hide();

	// Owl Carousel instances -- on home page:
	if ( $('.news-carousel--news').length > 0 ) {
		var owl = $('.news-carousel--news');
		owl.owlCarousel(
			{
				'loop': true,
				'nav': true,
				'margin': 10,
				'dots': true,
				// 'lazyLoad': true,
				'navText': ['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>'],
				responsive:{
			        0:{
			            items:1
			        },
			        768:{
			            items:2
			        }
			    }
			}
		);

		owl.on('changed.owl.carousel', function(event) {
			var current = event.page.index;

			$('.news-jump').each(function() {
				if ($(this).attr('data-target') == current) {
					$(this).addClass('news-jump--active');
				} else {
					$(this).removeClass('news-jump--active');
				}
			})

		})

		$('.news-jump').click(function() {
			owl.trigger('to.owl.carousel', [$(this).attr('data-target'), 300]);
		})
	}

	if ( $('.news-carousel--events').length > 0) {
		var owlEvents = $('.news-carousel--events');
		owlEvents.owlCarousel(
			{
				'loop': true,
				'nav': true,
				'margin': 10,
				'dots': true,
				// 'lazyLoad': true,
				'navText': ['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>'],
				responsive:{
			        0:{
			            items:1
			        },
			        768:{
			            items:2
			        }
			    }
			}
		);

		owlEvents.on('changed.owl.carousel', function(event) {
			var current = event.page.index;

			$('.news-jump').each(function() {
				if ($(this).attr('data-target') == current) {
					$(this).addClass('news-jump--active');
				} else {
					$(this).removeClass('news-jump--active');
				}
			})

		})

		$('.news-jump').click(function() {
			owlEvents.trigger('to.owl.carousel', [$(this).attr('data-target'), 300]);
		})
	}

	$('.news-carousel__tab-nav--news').click(function() {
		$('.news-carousel__owl-news').show();
		$('.news-carousel__owl-events').hide();

		if ( $('.news-carousel__tab-nav--events').hasClass('tab-nav--active') ) {
			$('.news-carousel__tab-nav--events').removeClass('tab-nav--active');
		}

		if ( ! $(this).hasClass('tab-nav--active') ) {
			$(this).addClass('tab-nav--active');
		}

	});

	$('.news-carousel__tab-nav--events').click(function() {
		$('.news-carousel__owl-events').show();
		$('.news-carousel__owl-news').hide();

		if ( $('.news-carousel__tab-nav--news').hasClass('tab-nav--active') ) {
			$('.news-carousel__tab-nav--news').removeClass('tab-nav--active');
		}

		if ( ! $(this).hasClass('tab-nav--active') ) {
			$(this).addClass('tab-nav--active');
		}

	});

	// Testimonials Carousel
	if ( $('.testimonials__slides').length > 0 ) {
		var owlTestimonials = $('.testimonials__slides');
		owlTestimonials.owlCarousel(
			{
				'loop': true,
				'items': 1,
				'autoplay': true,
				'nav': true,
				'dots': false,
				'lazyLoad': true,
				'navText': ['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>']
			}
		);
	}

	// Journal Articles Carousel
	if ( $('.journal-articles__slides').length > 0 ) {
		var owlArticles = $('.journal-articles__slides');
		owlArticles.owlCarousel(
			{
				'loop': true,
				'items': 1,
				'autoplay': true,
				'nav': true,
				'dots': false,
				'lazyLoad': true,
				'navText': ['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>']
			}
		);
	}
});
